import axios from '../axios'

//省
export const getProvince = (params) => {
  return axios({
    url: '/show/getProvinceList.do',
    method: 'get',
    params
  })
}

export const getCity = (params) => {
  return axios({
    url: '/show/getCityList.do',
    method: 'get',
    params
  })
}
export const getCountry = (params) => {
  return axios({
    url: '/show/getCountyList.do',
    method: 'get',
    params
  })
}

export const getTown = (params) => {
  return axios({
    url: '/show/getTownList.do',
    method: 'get',
    params
  })
}

export const getVillage = (params) => {
  return axios({
    url: '/show/getVillageList.do',
    method: 'get',
    params
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/area.js